import { Table } from 'antd';
import DownloadComponent from 'components/Global/Download';
import { useSelector } from 'react-redux';
import { formatDate, invalidText } from 'utils/utils';
import styles from './index.module.scss';
import Ellipse from 'components/Global/Ellipse';

const { Column } = Table;

type Props = {
	ReportData: any;
	totalRecords: number;
	currentPage: number;
	pageSize: number;
	tableChangeHandler: (pagination: any, filter: any, sorter: any) => void;
	isLoading: boolean;
	isCurrency?: boolean;
	variant?: 'default' | 'p18';
};

const GlobalReportTable = (props: Props) => {
	const {
		ReportData,
		totalRecords,
		currentPage,
		pageSize,
		tableChangeHandler,
		isLoading,
		isCurrency,
		variant = 'default',
	} = props;

	const { data: profileData } = useSelector(
		(state: any) => state?.userProfile
	);

	return (
		<div className={styles['dynamic-table']}>
			<Table
				dataSource={ReportData}
				scroll={{ y: 'calc(100vh - 360px)', x: 'max-content' }}
				pagination={{
					total: totalRecords,
					current: currentPage,
					pageSize: pageSize,
					showSizeChanger: false,
					pageSizeOptions: [10, 20, 50, 100, 200],
				}}
				onChange={tableChangeHandler}
				rowKey={(record: any) => record.id}
				loading={isLoading}
			>
				{variant === 'p18' ? (
					<>
						<Column
							title="Year"
							dataIndex={['payPeriod', 'year']}
							key="year"
							width={120}
							fixed="left"
							className="bg-white"
							render={(year) => year ?? '-'}
						/>
						<Column
							title="Branch"
							dataIndex="branches"
							key="branch"
							className="bg-white"
							width={240}
							render={(text, record: { id: string }) => {
								const content = !invalidText(text) ? text : '-';

								return (
									<Ellipse
										maxLength={30}
										message={content}
										isTooltip
										tooltipMessage={content}
										key={`branch-${record.id}`}
									/>
								);
							}}
						/>
						<Column
							title="Department"
							dataIndex="departments"
							key="department"
							className="bg-white"
							width={240}
							render={(text, record: { id: string }) => {
								const content = !invalidText(text) ? text : '-';

								return (
									<Ellipse
										maxLength={30}
										message={content}
										isTooltip
										tooltipMessage={content}
										key={`dept-${record.id}`}
									/>
								);
							}}
						/>
								<Column
							title="Employees"
							dataIndex="noOfEmployees"
							key="noOfEmployees"
							width={120}
							sorter={true}
							className="bg-white"
						/>
						<Column
							title="Report"
							dataIndex="documentLink"
							key="documentLink"
							className="bg-white"
							width={320}
							fixed="right"
							render={(text, record: any) => (
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'start',
									}}
								>
									{record.documentUrl ? (
										<DownloadComponent
											documentUrl={record.documentUrl}
											showTooltip={true}
											downloadText={record.documentName}
											text={record.documentName}
											isLink={true}
											maxLength={40}
										/>
									) : (
										'-'
									)}
								</div>
							)}
						/>
					</>
				) : (
					<>
						<Column
							title="Pay Period"
							dataIndex="payPeriod"
							key="payPeriod"
							width={270}
							fixed="left"
							className="bg-white"
							render={(text) => text?.name}
						/>

						<Column
							title="Generated Date"
							dataIndex="createdAt"
							key="createdAt"
							sorter={true}
							width={180}
							className="bg-white"
							render={(value) =>
								formatDate(
									value,
									profileData?.companyDateFormat ?? 'DD/MM/YYYY'
								)
							}
						/>

						<Column
							title="Generated By"
							dataIndex="createdBy"
							key="createdBy"
							width={180}
							className="bg-white"
							render={(text) => text?.fullName}
						/>

						<Column
							title="Branch"
							dataIndex="branches"
							key="branch"
							className="bg-white"
							width={240}
							render={(text, record: { id: string }) => {
								const content = !invalidText(text) ? text : '-';

								return (
									<Ellipse
										maxLength={30}
										message={content}
										isTooltip
										tooltipMessage={content}
										key={`branch-${record.id}`}
									/>
								);
							}}
						/>

						<Column
							title="Department"
							dataIndex="departments"
							key="department"
							className="bg-white"
							width={240}
							render={(text, record: { id: string }) => {
								const content = !invalidText(text) ? text : '-';

								return (
									<Ellipse
										maxLength={30}
										message={content}
										isTooltip
										tooltipMessage={content}
										key={`dept-${record.id}`}
									/>
								);
							}}
						/>

						<Column
							title="Employees"
							dataIndex="noOfEmployees"
							key="noOfEmployees"
							width={120}
							sorter={true}
							className="bg-white"
						/>
						{isCurrency && (
							<Column
								title="Currency"
								dataIndex="currency"
								key="currency"
								width={120}
								className="bg-white"
								render={(value) =>
									value === 'BOTH' ? '-' : value || '-'
								}
							/>
						)}
						<Column
							title="Report"
							dataIndex="documentLink"
							key="documentLink"
							className="bg-white"
							width={320}
							fixed="right"
							render={(text, record: any) => (
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'start',
									}}
								>
									{record.documentUrl ? (
										<DownloadComponent
											documentUrl={record.documentUrl}
											showTooltip={true}
											downloadText={record.documentName}
											text={record.documentName}
											isLink={true}
											maxLength={40}
										/>
									) : (
										'-'
									)}
								</div>
							)}
						/>
					</>
				)}
			</Table>
		</div>
	);
};

export default GlobalReportTable;
